import { createTranslations } from './i18n/types';

export default createTranslations({
  en: {
    loading: 'Initializing application...',
    errorProfileLoad: 'Failed to load profile: {{error}}',
    errorUnexpected: 'An unexpected error occurred',
    errorSteamAlreadyLinked: 'This Steam account is already linked to another user',
    errorUserAlreadySteamLinked: 'Your account already has a linked Steam account',
    errorLinkFailed: 'Failed to link account: {{error}}',
  },
  ru: {
    loading: 'Инициализация приложения...',
    errorProfileLoad: 'Ошибка загрузки профиля: {{error}}',
    errorUnexpected: 'Произошла неожиданная ошибка',
    errorSteamAlreadyLinked: 'Этот аккаунт Steam уже привязан к другому пользователю',
    errorUserAlreadySteamLinked: 'К твоему аккаунту уже привязан Steam',
    errorLinkFailed: 'Ошибка привязки аккаунта: {{error}}',
  },
  uz: {
    loading: 'Ilova ishga tushirilmoqda...',
    errorProfileLoad: 'Profilni yuklashda xatolik: {{error}}',
    errorUnexpected: 'Kutilmagan xatolik yuz berdi',
    errorSteamAlreadyLinked: 'Bu Steam akkaunt boshqa foydalanuvchiga bogʻlangan',
    errorUserAlreadySteamLinked: 'Akkauntingizga allaqachon Steam bogʻlangan',
    errorLinkFailed: 'Akkauntni bogʻlashda xatolik: {{error}}',
  },
  fa: {
    loading: 'در حال آماده‌سازی برنامه...',
    errorProfileLoad: 'بارگذاری پروفایل ناموفق بود: {{error}}',
    errorUnexpected: 'خطای غیرمنتظره‌ای رخ داد',
    errorSteamAlreadyLinked: 'این حساب استیم قبلاً به کاربر دیگری وصل شده',
    errorUserAlreadySteamLinked: 'حساب تو از قبل یک حساب استیم متصل دارد',
    errorLinkFailed: 'اتصال حساب ناموفق بود: {{error}}',
  },
  pt: {
    loading: 'Iniciando o aplicativo...',
    errorProfileLoad: 'Erro ao carregar o perfil: {{error}}',
    errorUnexpected: 'Ocorreu um erro inesperado',
    errorSteamAlreadyLinked: 'Esta conta Steam já está vinculada a outro usuário',
    errorUserAlreadySteamLinked: 'Sua conta já tem uma conta Steam vinculada',
    errorLinkFailed: 'Erro ao vincular a conta: {{error}}',
  },
  tr: {
    loading: 'Uygulama başlatılıyor...',
    errorProfileLoad: 'Profil yüklenemedi: {{error}}',
    errorUnexpected: 'Beklenmeyen bir hata oluştu',
    errorSteamAlreadyLinked: 'Bu Steam hesabı zaten başka bir kullanıcıya bağlı',
    errorUserAlreadySteamLinked: 'Hesabına zaten bir Steam hesabı bağlı',
    errorLinkFailed: 'Hesap bağlanamadı: {{error}}',
  },
  uk: {
    loading: 'Ініціалізація застосунку...',
    errorProfileLoad: 'Не вдалося завантажити профіль: {{error}}',
    errorUnexpected: 'Сталася неочікувана помилка',
    errorSteamAlreadyLinked: 'Цей акаунт Steam уже прив’язаний до іншого користувача',
    errorUserAlreadySteamLinked: 'До твого акаунта вже прив’язаний Steam',
    errorLinkFailed: 'Не вдалося прив’язати акаунт: {{error}}',
  },
  de: {
    loading: 'App wird gestartet...',
    errorProfileLoad: 'Profil konnte nicht geladen werden: {{error}}',
    errorUnexpected: 'Es ist ein unerwarteter Fehler aufgetreten',
    errorSteamAlreadyLinked: 'Dieses Steam-Konto ist bereits mit einem anderen Nutzer verknüpft',
    errorUserAlreadySteamLinked: 'Mit deinem Konto ist bereits ein Steam-Konto verknüpft',
    errorLinkFailed: 'Konto konnte nicht verknüpft werden: {{error}}',
  },
  es: {
    loading: 'Iniciando la aplicación...',
    errorProfileLoad: 'No se pudo cargar el perfil: {{error}}',
    errorUnexpected: 'Se produjo un error inesperado',
    errorSteamAlreadyLinked: 'Esta cuenta de Steam ya está vinculada a otro usuario',
    errorUserAlreadySteamLinked: 'Tu cuenta ya tiene una cuenta de Steam vinculada',
    errorLinkFailed: 'No se pudo vincular la cuenta: {{error}}',
  },
  pl: {
    loading: 'Uruchamianie aplikacji...',
    errorProfileLoad: 'Nie udało się wczytać profilu: {{error}}',
    errorUnexpected: 'Wystąpił nieoczekiwany błąd',
    errorSteamAlreadyLinked: 'To konto Steam jest już połączone z innym użytkownikiem',
    errorUserAlreadySteamLinked: 'Do twojego konta jest już podłączony Steam',
    errorLinkFailed: 'Nie udało się połączyć konta: {{error}}',
  },
});
